module.exports = __webpack_public_path__ + "img/quest_icon_0068_fight.0787dcc2.png";